var map = {
  "./assets/favicons-prodcan1/android-chrome-192x192.png": "92750",
  "./assets/favicons-prodcan1/android-chrome-512x512.png": "87374",
  "./assets/favicons-prodcan1/apple-touch-icon.png": "27201",
  "./assets/favicons-prodcan1/browserconfig.xml": "40885",
  "./assets/favicons-prodcan1/favicon-16x16.png": "84115",
  "./assets/favicons-prodcan1/favicon-32x32.png": "30652",
  "./assets/favicons-prodcan1/favicon-alert-16x16.png": "27409",
  "./assets/favicons-prodcan1/favicon-alert-32x32.png": "39121",
  "./assets/favicons-prodcan1/favicon-alert.ico": "75762",
  "./assets/favicons-prodcan1/favicon.ico": "187",
  "./assets/favicons-prodcan1/mstile-150x150.png": "63090",
  "./assets/favicons-prodcan1/site.webmanifest": "75088",
  "./assets/favicons-prodcan1/upc-favicon.ico": "17446"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 45821;
